import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

export function ReassuranceSection(props) {
  return (
    <section className="reassuranceSectionOuter">
      <div className="reassuranceSection">
        <h2 className="mediumHeadline textCentre white">
          Smart Safety, Without the Stress
        </h2>

        <div className="reassuranceItems">
          <div className="reassuranceItem">
            <CheckCircleOutlined
              style={{ color: "#8CC640", fontSize: "24px" }}
            />
            <span>No credit card required</span>
          </div>
          <div className="reassuranceItem">
            <CheckCircleOutlined
              style={{ color: "#8CC640", fontSize: "24px" }}
            />
            <span>Free 30-day trial for all features</span>
          </div>
          <div className="reassuranceItem">
            <CheckCircleOutlined
              style={{ color: "#8CC640", fontSize: "24px" }}
            />
            <span>Cancel anytime</span>
          </div>
        </div>

        <Link to="/get-a-demo">
          <button className="roundBtn startTrialBtn">
            Start your Free Trial
          </button>
        </Link>
      </div>
    </section>
  );
}
